import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-think-twice',
  templateUrl: './modal-think-twice.component.html',
  styleUrls: ['./modal-think-twice.component.scss'],
})
export class ModalThinkTwiceComponent {

  @Input() title = '';
  @Input() description = '';
  @Input() applyActivated = true;
  @Input() innerModal = false;
  @Input() modalButtons = {
    dismiss: 'Cancel',
    apply: 'Continue',
  };

  @Output() confirmEmitter = new EventEmitter<boolean>();

  close(value: boolean) {
    this.confirmEmitter.emit(value);
  }
}
